import { useMutation } from '@apollo/client';
import { graphql } from '@client/graphql/types';

const UPDATE = graphql(`
  mutation deleteTopBanner($id: ID!) {
    deleteTopBanner(id: $id) {
      ...TopBannerItem
    }
  }
`);

export function useDeleteTopBanners() {
  return useMutation(UPDATE, {
    refetchQueries: ['topBanners', 'topBanner'],
  });
}
